window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
}

// Huntサイズ画像変更
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hunt-both.gif?v=1643521338";
document.getElementById("message").innerHTML = "<p>(幅100～190cmまで1cm単位でオーダー可能です。)</p>";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hunt-right.gif?v=1643521421";
document.getElementById("message").innerHTML = "<p>(幅100～190cmまで1cm単位でオーダー可能です。)</p>";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hunt-left.gif?v=1643521421";
document.getElementById("message").innerHTML = "<p>(幅100～190cmまで1cm単位でオーダー可能です。)</p>";
}
function showimg4(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/hunt-armless.gif?v=1643521439";
document.getElementById("message").innerHTML = "<p>(幅100～180cmまで1cm単位でオーダー可能です。)</p>";
}

// Hunt サイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "cava_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";

    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_haba.innerHTML=""; 
    cart_color.innerHTML="";
    cart_productform.innerHTML="";
    cart_cloth.innerHTML="";

 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}


const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,price,cloth){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;}
function searchURL(strHaba,strDepth,strHeight,strCloth){
var strErr;
//var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value


//幅チェック
if (intHaba < 100){
 strErr="幅100cm未満";
}else if (strDepth=="armless"&&intHaba > 180){
  strErr="幅181cm以上";
}else if (intHaba > 190){
  strErr="幅191cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}
    
    
//幅サイズ成形
switch(strHaba.length){
	case 3:
		if(strHaba.slice(-1)=="0"){
			
		}else{
		strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
		}
		break;
}

 
//ベース価格
var basePrice = [58000,92000,115000,57000,80000,94000,108000];
var addPrice = 2000;
var mulHaba;
var sellPrice;
var i=0
 mulHaba=(parseInt(strHaba)-100)/10;
 if(strDepth=="armless"){
  if(strCloth=="ns7" || strCloth=="meisai"){
   sellPrice =  parseInt(basePrice[i+3])+(parseInt(addPrice)*parseInt(mulHaba));
  }/*else if(strCloth=="oct" || strCloth=="flower"){
   sellPrice =  parseInt(basePrice[i+5])+(parseInt(addPrice)*parseInt(mulHaba));
  }*/else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="moq" || strCloth=="magic" || strCloth=="holiday" || strCloth=="meta"){
   sellPrice =  parseInt(basePrice[i+4])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="michael"){
   sellPrice =  parseInt(basePrice[i+5])+(parseInt(addPrice)*parseInt(mulHaba));
  }else{
   alert("生地を選択してください");
   return false;
  }
 }else{
  if(strCloth=="ns7" || strCloth=="meisai"){
   sellPrice =  parseInt(basePrice[i])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="oct" || strCloth=="flower"){
   sellPrice =  parseInt(basePrice[i+1])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="denim" || strCloth=="damaska" || strCloth=="damaskb" || strCloth=="moq" || strCloth=="magic" || strCloth=="holiday" || strCloth=="meta"){
   sellPrice =  parseInt(basePrice[i+1])+(parseInt(addPrice)*parseInt(mulHaba));
  }else if(strCloth=="michael"){
   sellPrice =  parseInt(basePrice[i+1])+(parseInt(addPrice)*parseInt(mulHaba));
  }else{
   alert("生地を選択してください");
   return false;
  }
 }
 return sellPrice;
}





/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].cloth==strCloth){
return goods[i].url;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_productform.innerHTML="";
 cart_haba.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=""
var idProductForm=document.getElementsByName( "productform" ) ;
var strHaba=document.getElementById("haba").value;
var strHeight="";
var idCloth = document.getElementsByName( "cava_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var strCloth = "";
var strColor = "";
var i=0;
var a=0;
var b=0;
for ( strDepth="", b=idProductForm.length; b--; ) {
 if ( idProductForm[b].checked ) {
  strDepth = idProductForm[b].id ;
  var valueProductForm = idProductForm[b].value ;
  break ;
 }
}
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}




document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=valueProductForm+"タイプ"
document.getElementById("choice3").value=valueCloth+"生地"
document.getElementById("choice4").value=valueColor

//商品ページの有無チェック（別注色シルバーグレー追加）
var comcode=checkURL(strHaba,strDepth,strHeight,strCloth,strColor);
if (!comcode=="" && strColor=="moq_sgy"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="モケット生地シルバーグレーは別注色のため金額が異なります。";
}
else if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strCloth);

if(!url){
alert("幅を入力してください");
return false;
}

var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_productform.innerHTML=valueProductForm;
 cart_haba.innerHTML=strHaba;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice5").value="見積もり金額："+url;
return false;
}

function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;  
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a01154","190","both","","64000","oct");
goods[1] =new setGoods("0000a01158","190","both","","75000","moq");
goods[2] =new setGoods("0000a01172","190","both","","75000","leather");
goods[3] =new setGoods("0000a02190","100","both","","49000","oct");
goods[4] =new setGoods("0000a02194","100","both","","60000","leather");
goods[5] =new setGoods("0000a02196","100","both","","60000","moq");
goods[6] =new setGoods("0000a02726","190","both","","54000","ns7");
goods[7] =new setGoods("0000a02732","100","both","","39000","ns7");
goods[8] =new setGoods("0000a03767","100","both","","70000","caleido");
goods[9] =new setGoods("0000a03819","190","both","","97000","caleido");
goods[10] =new setGoods("0000a04788","180","armeless","","60000","oct");
goods[11] =new setGoods("0000a04792","180","armeless","","70000","moq");
goods[12] =new setGoods("0000a04793","180","armeless","","70000","leather");
goods[13] =new setGoods("0000a04801","180","armeless","","49000","ns7");
goods[14] =new setGoods("0000a04807","190","right","","64000","oct");
goods[15] =new setGoods("0000a04811","190","right","","75000","moq");
goods[16] =new setGoods("0000a04812","190","right","","75000","leather");
goods[17] =new setGoods("0000a04820","190","right","","54000","ns7");
goods[18] =new setGoods("0000a04826","190","left","","64000","oct");
goods[19] =new setGoods("0000a04830","190","left","","75000","moq");
goods[20] =new setGoods("0000a04831","190","left","","75000","leather");
goods[21] =new setGoods("0000a04839","190","left","","54000","ns7");
goods[22] =new setGoods("0000a23541","190","both","","75000","chappy");
goods[23] =new setGoods("0000a23543","190","both","","75000","damaska");
goods[24] =new setGoods("0000a23546","190","both","","75000","damaskb");
goods[25] =new setGoods("0000a23549","190","both","","54000","meisai");
goods[26] =new setGoods("0000a23552","190","both","","64000","flower");
goods[27] =new setGoods("0000a23567","100","both","","60000","chappy");
goods[28] =new setGoods("0000a23568","180","armeless","","70000","chappy");
goods[29] =new setGoods("0000a23569","180","armeless","","92000","caleido");
goods[30] =new setGoods("0000a23588","180","armeless","","70000","damaska");
goods[31] =new setGoods("0000a23591","180","armeless","","70000","damaskb");
goods[32] =new setGoods("0000a23594","180","armeless","","49000","meisai");
goods[33] =new setGoods("0000a23597","180","armeless","","60000","flower");
goods[34] =new setGoods("0000a23599","190","right","","75000","chappy");
goods[35] =new setGoods("0000a23600","190","right","","97000","caleido");
goods[36] =new setGoods("0000a23619","190","right","","75000","damaska");
goods[37] =new setGoods("0000a23622","190","right","","75000","damaskb");
goods[38] =new setGoods("0000a23625","190","right","","54000","meisai");
goods[39] =new setGoods("0000a23628","190","right","","64000","flower");
goods[40] =new setGoods("0000a23630","190","left","","75000","chappy");
goods[41] =new setGoods("0000a23631","190","left","","97000","caleido");
goods[42] =new setGoods("0000a23650","190","left","","75000","damaska");
goods[43] =new setGoods("0000a23653","190","left","","75000","damaskb");
goods[44] =new setGoods("0000a23656","190","left","","54000","meisai");
goods[45] =new setGoods("0000a23659","190","left","","64000","flower");
goods[46] =new setGoods("0000a23850","100","both","","60000","damaska");
goods[47] =new setGoods("0000a23853","100","both","","60000","damaskb");
goods[48] =new setGoods("0000a23856","100","both","","39000","meisai");
goods[49] =new setGoods("0000a23859","100","both","","49000","flower");
goods[50] =new setGoods("0000a35796","190","both","","78000","michael");
goods[51] =new setGoods("0000a35816","100","both","","61000","michael");
goods[52] =new setGoods("0000a35826","180","armeless","","74000","michael");
goods[53] =new setGoods("0000a35836","190","right","","78000","michael");
goods[54] =new setGoods("0000a35846","190","left","","78000","michael");
goods[55] =new setGoods("0000a41130","190","both","","75000","denim");
goods[56] =new setGoods("0000a41140","100","both","","60000","denim");
goods[57] =new setGoods("0000a41145","180","armeless","","70000","denim");
goods[58] =new setGoods("0000a41150","190","right","","75000","denim");
goods[59] =new setGoods("0000a41155","190","left","","75000","denim");